import React from 'react';
import styles from './components.module.css';

export interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryText?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Erro ao carregar',
  message,
  onRetry,
  retryText = 'Tentar novamente',
}) => {
  return (
    <div className={styles.errorContainer}>
      <h3 className={styles.errorTitle}>{title}</h3>
      <p className={styles.errorMessage}>{message}</p>
      {onRetry && (
        <button type="button" className={styles.retryButton} onClick={onRetry}>
          {retryText}
        </button>
      )}
    </div>
  );
};

export default ErrorState;
